<template>
  <div class="bg-white p-4 rounded-small shadow-theme relative text-center">
    <div v-if="isScoreSurvey" class="total-score">
      <span>总分：</span>
      <span>{{ totalScoreValue }}</span>
    </div>
    <option-senior-input
      v-model="surveyTitle"
      size="large"
      placeholder="请填写问卷调查标题"
      placeholder-align="center"
      @change="onChangeTitle"
      @append-image="onAppendImage"
      :seniors="['editor']"
      :senior-editor-toolbar="[['fontsizeselect'], ['alignleft aligncenter alignright alignjustify'], ['removeformat']]"
      senior-editor-default-style="text-align:center;font-size:20px"
      preText="请填写问卷调查标题"
      ref="surveyTitle"
    />
    <senior-text-input
      v-model="surveyWelcome"
      :allow-empty="true"
      class="mt-3"
      placeholder-align="center"
      :placeholder="placeholder"
      :seniors="['editor', 'image']"
      @change="onChangeWelcome"
      @append-image="onAppendWelcomeImage"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RichTextInput from '@/components/base/RichTextInput'
import SeniorTextInput from '@/components/base/SeniorTextInput'
import { html2text } from '@dygc/shared'
import GlobalConfig from '@/global/config'
import { ScoreType } from '@/question/components/score/types'
import { surveyLoading } from '@/assets/js/el-loading'
import { questionType } from '@dygc/question'
import { updateBankName } from '@/api/wenjuan/bankList'
import { getScoreValue } from '@/question/util'
import OptionSeniorInput from '@/question/components/OptionSeniorInput'
import { SET_IS_HEADER, SET_SELECT_QUESTION } from '@/store/survey/mutation-types'

export default {
  name: 'TitleAndWelcome',
  components: { OptionSeniorInput, RichTextInput, SeniorTextInput },
  props: {
    surveyId: {
      type: String,
      default: ''
    }
  },
  computed: {
    totalScoreValue() {
      return getScoreValue(this.answerScoreList)
    },
    placeholder(){
      switch (this.$route.query.scene) {
        case 'Default':
          return '请添加开始语，例如“感谢您愿意抽出几分钟时间参与本次答题，我们现在开始吧！”'
        case 'Score':
          return '请添加开始语，例如“欢迎参加本次考试“'
        case 'Vote':
          return '请添加开始语，例如“欢迎参与本次投票！”'
        case 'SignIn':
          return '请添加开始语，例如“欢迎报名”'
        case 'Solitaire':
          return '请添加开始语，例如“欢迎参与本次接龙”'
        case 'Evaluation':
          return '请添加开始语，例如“欢迎参与本次测评，我们现在开始吧！”'
        case 'Satisfaction':
          return '请添加开始语，例如“欢迎参与本次满意度调查，我们现在开始吧！”'
        case 'ClockIn':
          return '请添加开始语，例如“请完成本次打卡”'
        case 'Appointment':
          return '请添加开始语，例如“请认真填表，完成预约”'
        case 'MakeCollections':
          return '请添加开始语，例如“欢迎参与本次收款，我们现在开始吧！”'
        case 'LandingPage':
          return '请添加开始语，例如“欢迎参与本次落地页，我们现在开始吧！”'
        default:
          return '请添加开始语，例如“感谢您愿意抽出几分钟时间参与本次答题，我们现在开始吧！”'
      }
    },
    ...mapGetters(['titlex', 'title', 'welcome', 'surveyInit', 'answerScoreList', 'isScoreSurvey','otherSetting'])
  },
  created() {
    if (!this.surveyInit) {
      let uw = this.$watch('surveyInit', () => {
        this.init()
        uw && uw()
      })
    } else {
      this.init()
    }
  },
  data() {
    return {
      surveyTitle: '',
      surveyWelcome: '',
      //isHeaderShow: true
    }
  },
  methods: {
    onAppendImage(data, html) {
      this.surveyTitle = html
      this.onChangeTitle()
    },
    // 更新题库分类名称
    setUpdateBankName(params) {
      updateBankName({ ...params }).then(res => {
        if (res.data.code === 0) {
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onChangeTitle() {
      if (this.$route.name === 'bank-edit-question') {
        let text = html2text(this.surveyTitle)
        if (text.length > 12) {
          this.$message.warning('题库字数最大不能超过12字')
          this.surveyTitle = this.titlex
          this.$refs.surveyTitle.refresh()
          return
        }
        this.setUpdateBankName({
          title: this.surveyTitle,
          surveyId: GlobalConfig.getSurveyId()
        })
      }
      let text = html2text(this.surveyTitle)
      if (text.length > 200) {
        this.$message.warning('标题字数最大不能超过200字')
        this.surveyTitle = this.titlex
        this.$refs.surveyTitle.refresh()
        return
      }
      this.onUpdate({
        title: text,
        titlex: this.surveyTitle,
        welcome: this.surveyWelcome
      })
    },
    onAppendWelcomeImage(data, html) {
      this.surveyWelcome = html
      this.onChangeWelcome()
    },
    onChangeWelcome() {
      this.onUpdate({
        title: this.title,
        titlex: this.titlex,
        welcome: this.surveyWelcome
      })
    },
    onUpdate(data = {}) {
      surveyLoading(() => {
        return this.$store.dispatch(
          'updateSurveyTitleAndWelcome',
          Object.assign({ surveyId: GlobalConfig.getSurveyId() || this.surveyId }, data)
        )
      })
    },
    init() {
      this.surveyTitle = this.titlex
      this.surveyWelcome = this.welcome
      this.$watch('title', (val, oldValue) => {
        this.surveyTitle = val
        if (this.$refs.surveyTitle) {
          this.$refs.surveyTitle.refresh()
        }
        this.onChangeTitle()
      })
      // let uw = this.$watch('otherSetting', () => {
      //   console.log('55555666777', this.otherSetting)
      //   this.isHeaderShow = true
      //   // uw && uw()
      // })
    }
  }
}
</script>
